// Comprehensive dummy product data for Farmero Organics
// Using real locations from different districts of Nepal

export interface DummyProduct {
  id: number;
  slug: string;
  product_name: string;
  name?: string;
  description: string;
  price: number;
  price_unit: string;
  featured: boolean;
  is_latest: boolean;
  best_seller_pro: boolean;
  lat: number;
  lng: number;
  origin: string;
  district: string;
  category: string | { name: string };
  rating: number;
  average_rating?: number;
  reviewCount: number;
  review_count?: number;
  image: string;
  images?: string[];
  featured_image?: { image?: string; path?: string };
  isOrganic: boolean;
  is_organic?: boolean;
  stock: number;
  discount?: number;
  location?: {
    address?: string;
    farm_name?: string;
  };
}

export const dummyProducts: DummyProduct[] = [
  {
    id: 1,
    slug: "organic-himalayan-honey",
    product_name: "Organic Himalayan Honey",
    name: "Organic Himalayan Honey",
    description: "Pure mountain honey from Kaski district beekeepers",
    price: 1200,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: true,
    best_seller_pro: true,
    lat: 28.2096,
    lng: 83.9856,
    origin: "Kaski Valley Farms",
    district: "Kaski",
    category: "Honey & Bee Products",
    rating: 4.9,
    average_rating: 4.9,
    reviewCount: 142,
    review_count: 142,
    image: "https://images.pexels.com/photos/4192920/pexels-photo-4192920.jpeg",
    images: [
      "https://images.pexels.com/photos/4192920/pexels-photo-4192920.jpeg",
    ],
    isOrganic: true,
    is_organic: true,
    stock: 250,
  },
  {
    id: 2,
    slug: "basmati-rice-kailali",
    product_name: "Premium Basmati Rice",
    name: "Premium Basmati Rice",
    description: "Aromatic organic rice from Kailali plains",
    price: 180,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: false,
    best_seller_pro: true,
    lat: 28.705,
    lng: 80.565,
    origin: "Kailali Organic Cooperative",
    district: "Kailali",
    category: "Grains & Cereals",
    rating: 4.8,
    average_rating: 4.8,
    reviewCount: 98,
    review_count: 98,
    image: "https://images.pexels.com/photos/1393382/pexels-photo-1393382.jpeg",
    isOrganic: true,
    is_organic: true,
    stock: 500,
  },
  {
    id: 3,
    slug: "fresh-tomatoes-chitwan",
    product_name: "Fresh Organic Tomatoes",
    name: "Fresh Organic Tomatoes",
    description: "Handpicked red tomatoes from Chitwan valley",
    price: 80,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: true,
    best_seller_pro: true,
    lat: 27.5291,
    lng: 84.3542,
    origin: "Chitwan Valley Farms",
    district: "Chitwan",
    category: "Fresh Vegetables",
    rating: 4.7,
    average_rating: 4.7,
    reviewCount: 215,
    review_count: 215,
    image: "https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg",
    isOrganic: true,
    is_organic: true,
    stock: 300,
  },
  {
    id: 4,
    slug: "organic-carrots-mustang",
    product_name: "Organic Carrots",
    name: "Organic Carrots",
    description: "Crisp, sweet carrots grown without pesticides",
    price: 60,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: false,
    best_seller_pro: false,
    lat: 28.8333,
    lng: 83.8333,
    origin: "Mustang Highlands",
    district: "Mustang",
    category: "Fresh Vegetables",
    rating: 4.6,
    average_rating: 4.6,
    reviewCount: 89,
    review_count: 89,
    image: "https://images.pexels.com/photos/1598170845058-32b9d6a5da37.jpeg",
    isOrganic: true,
    is_organic: true,
    stock: 200,
  },
  {
    id: 5,
    slug: "organic-rice-janakpur",
    product_name: "Organic Rice",
    name: "Organic Rice",
    description: "Premium quality organic rice from Janakpur",
    price: 150,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: false,
    best_seller_pro: true,
    lat: 26.7288,
    lng: 85.9254,
    origin: "Janakpur Farms",
    district: "Dhanusha",
    category: "Grains & Cereals",
    rating: 4.8,
    average_rating: 4.8,
    reviewCount: 156,
    review_count: 156,
    image: "https://images.pexels.com/photos/1306548/pexels-photo-1306548.jpeg",
    isOrganic: true,
    is_organic: true,
    stock: 400,
  },
  {
    id: 6,
    slug: "fresh-spinach-lalitpur",
    product_name: "Fresh Spinach",
    name: "Fresh Spinach",
    description: "Fresh organic spinach from Lalitpur",
    price: 50,
    price_unit: "Rs/kg",
    featured: true,
    is_latest: true,
    best_seller_pro: false,
    lat: 27.6667,
    lng: 85.3333,
    origin: "Lalitpur Organic Farms",
    district: "Lalitpur",
    category: "Fresh Vegetables",
    rating: 4.5,
    average_rating: 4.5,
    reviewCount: 67,
    review_count: 67,
    image: "https://images.pexels.com/photos/1576045057995-568f588f82fb.jpeg",
    isOrganic: true,
    is_organic: true,
    stock: 150,
  },
];

export const getFeaturedProducts = () => {
  return dummyProducts.filter(p => p.featured);
};

